export const GET_DISCOVER_DETAILS = 'GET_DISCOVER_DETAILS';
